// Отправить запрос на сервер.

import {get} from '~/app/utils/ServerApi';
import {getState} from '../Store/index';
import {
	StateFilter,
	StateVisualBuilding,
	StateVisualFloor,
	StateVisualFloorMapItem,
	StateVisualMapItem,
	StateVisualOverview,
	StateVisualSection,
} from '../Store/State';
import visualStateToQueryString, {
	QueryParameters,
} from '../utils/visualStateToQueryString';

/**
 * Отправить запрос на сервер.
 * 
 * @param parameters Параметры запроса.
 * @returns Новый объект состояния.
 */
async function sendVisualRequest(
	parameters: QueryParameters = {},
): Promise<ServerNormalizedResponse>
{
	const state = getState();
	const query = visualStateToQueryString(
		state.filter,
		state.visualData,
		parameters,
	);
	const response = await get<ServerResponse>(
		'/choose/apartment/?ajax=1' + ( query ? '&' + query : '' ),
	);
	const result: ServerNormalizedResponse = {
		filter: response.filter,
	};
	
	if ( response.overview )
	{
		// TODO: overview подменён на building
		const overview = ((response.overview as any) as ServerResponseBuilding[]).map(
			(
				// {corpus, count}: ServerResponseOverview,
				{section, count}: ServerResponseBuilding,
			): StateVisualMapItem =>
			{
				return {
					path: '',
					// target: corpus,
					target: section,
					available: count,
				};
			},
		);
		result.overview = {map: overview};
	}
	
	if ( response.building )
	{
		const building = response.building.map(
			(
				{section, count}: ServerResponseBuilding,
			): StateVisualMapItem =>
			{
				return {
					path: '',
					target: section,
					available: count,
				};
			},
		);
		result.building = {map: building};
	}
	
	if ( response.section )
	{
		const section = response.section.map(
			(
				{floor, count}: ServerResponseSection,
			): StateVisualMapItem =>
			{
				return {
					path: '',
					target: floor,
					available: count,
				};
			},
		);
		result.section = {map: section};
	}
	
	if ( response.floor )
	{
		const floor = response.floor.map.map(
			(
				{id, room_type, square_total, total_cost, path}: ServerResponseFloorMap,
			): StateVisualFloorMapItem =>
			{
				return {
					target: id,
					roomType: room_type,
					squareTotal: square_total,
					totalCost: total_cost,
					path: path || '',
				};
			},
		);
		result.floor = {
			floor: response.floor.floor,
			image: response.floor.image,
			map: floor,
		};
	}
	
	return result;
}

/**
 * Ответ сервера.
 */
interface ServerResponse
{
	/** Описание полей фильтра */
	filter: StateFilter;
	/** Состояние общего экрана */
	overview?: ServerResponseOverview[];
	/** Состояние экрана секции */
	building?: ServerResponseBuilding[];
	/** Состояние экрана секции */
	section?: ServerResponseSection[];
	/** Состояние экрана этажа */
	floor?: ServerResponseFloor;
}

/**
 * Объект общего экрана с сервера.
 */
interface ServerResponseOverview
{
	/** Корпус */
	corpus: string;
	/** Количество квартир */
	count: number;
}

/**
 * Объект корпуса с сервера.
 */
interface ServerResponseBuilding
{
	/** Секция */
	section: string;
	/** Количество квартир */
	count: number;
}

/**
 * Объект секции с сервера.
 */
interface ServerResponseSection
{
	/** Этаж */
	floor: number;
	/** Количество квартир */
	count: number;
}

/**
 * Объект квартиры на этаже с сервера.
 */
interface ServerResponseFloor
{
	/** Этаж */
	floor: number;
	/** Путь до изображения */
	image: string;
	/** Карта областей */
	map: ServerResponseFloorMap[];
}

interface ServerResponseFloorMap
{
	/** ID в базе */
	id: number;
	/** Тип комнат */
	room_type: string;
	/** Общая площадь, м² */
	square_total: number;
	/** Общая цена */
	total_cost: number;
	/**  */
	path: string;
}

/**
 * Нормальзованный ответ сервера.
 */
interface ServerNormalizedResponse
{
	/** Описание полей фильтра */
	filter: StateFilter;
	/** Состояние общего экрана */
	overview?: Partial<StateVisualOverview>;
	/** Состояние экрана корпуса */
	building?: Partial<StateVisualBuilding>;
	/** Состояние экрана секции */
	section?: Partial<StateVisualSection>;
	/** Состояние экрана этажа */
	floor?: StateVisualFloor;
}

/**
 * Module.
 */
export {
	sendVisualRequest as default,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/utils/sendVisualRequest.ts